import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppLayoutModule } from './layout/app.layout.module';
import { NotfoundComponent } from './demo/components/notfound/notfound.component';
import { ProductService } from './demo/service/product.service';
import { CountryService } from './demo/service/country.service';
import { CustomerService } from './demo/service/customer.service';
import { EventService } from './demo/service/event.service';
import { IconService } from './demo/service/icon.service';
import { NodeService } from './demo/service/node.service';
import { PhotoService } from './demo/service/photo.service';
import { SpinnerComponent } from './_components/spinner/spinner.component';
import { CoreModule } from './core/core.module';
import { MessageService } from 'primeng/api';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';
import { RouterModule, Routes } from '@angular/router';

// Define your routes here
const routes: Routes = [
  // Add your app routes here
];

@NgModule({
  declarations: [
    AppComponent, NotfoundComponent, SpinnerComponent
  ],
  imports: [
    AppRoutingModule,
    AppLayoutModule,
    CommonModule,
    CoreModule,
    ToastModule,
    MessageModule,
    RouterModule.forRoot(routes, { useHash: false }) // Ensure useHash: false here
  ],
  providers: [
    // Remove HashLocationStrategy
    CountryService, CustomerService, EventService, IconService, NodeService,
    PhotoService, ProductService, MessageService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
